// extracted by mini-css-extract-plugin
export default {"wrapper":"f_y","content":"f_d","offer":"f_z","logo":"f_B","info":"f_C","button":"f_D","closeButton":"f_F","close":"f_G"};